export const DESKTOP_SUBLINKS_SEGMENT = 'desktop-sublinks-segment';
export const DESKTOP_SUBLINKS_SUBCATEGORY = 'desktop-sublinks-subcategory';
export const DESKTOP_SUBLINKS_NEW = 'desktop-sublinks-new';
export const DESKTOP_SUBLINKS_OTHER_LINKS = 'desktop-sublinks-other-links';
export const POPULAR_BRANDS = 'popular-brands';
export const DESKTOP_SUBLINKS_ROOT = 'desktop-sublinks-root';
export const POPULAR_BRANDS_ROOT = 'popular-brands-root';
export const SUBCATEGORY_LIST_ELEMENT = 'subcategory-list-element';
export const MOBILE_SUBCATEGORY_ROOT = 'mobile-subcategory-root';
export const POPULAR_BRANDS_LIST_ELEMENT = 'popular-brands-list-element';
export const SUBCATEGORY_LIST_ELEMENT_TITLE = 'subcategory-list-element-title';
export const SUBCATEGORY_SEGMENT = 'subcategory-segment';
export const DESKTOP_SUBCATEGORY_ROOT = 'desktop-subcategory-root';
export const SUBCATEGORY = 'subcategory';
export const MOBILE_SUBLINKS_ROOT = 'mobile-sublinks-root';
